import { useEffect, useState } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import { Link } from "react-router-dom";
import DeleteContact from "./DeleteContact";

const Contacts = () => {
    const { auth } = useAuth();
    const [contacts, setContacts] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [contactID, setContactID] = useState(null)

    useEffect(() => {
        const fetch = async () => {
            try {
                const response = await axiosPrivate.get("/contacts", {headers: {Authorization: "Bearer " + auth.accessToken}});
                setContacts(response.data);
            } catch(err) {
                console.log(err);
            }
        }
        fetch();
    }, [auth.accessToken, axiosPrivate]);

    const DeleteCont = (evt) => {
        setContactID(evt.target.id)
    }

    return (
        <div>
            {contactID && <DeleteContact contactID={contactID} setContactID={setContactID} setContacts={setContacts} />}
            <div style={{paddingBottom:'2rem'}}>
                <span className="relative flex justify-center">
                    <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-transparent bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-75"></div>
                    <span className="relative z-10 bg-white px-6">Contacts</span>
                </span>
            </div>
            <div>
                <Link to="/add-contact">
                    <strong className="rounded border border-indigo-500 bg-indigo-500 px-3 py-1.5 text-[13px] font-medium text-white">
                        Add Contact
                    </strong>
                </Link>

                <div className="overflow-x-auto" style={{paddingTop:'1.5rem'}}>
                    <table className="min-w-full divide-y-2 divide-gray-200 bg-white text-sm">
                        <thead className="ltr:text-left rtl:text-right">
                            <tr>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">First Name</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Last Name</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Designation</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Phone Number</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Email</th>
                                <th className="whitespace-nowrap px-4 py-2 font-medium text-gray-900 text-left">Action</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-200">
                            {contacts.map(contact => (
                                <tr className="odd:bg-gray-50" key={contact.id}>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{contact.first_name}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{contact.last_name}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{contact.title}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{contact.phone_num}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">{contact.email}</td>
                                    <td className="whitespace-nowrap px-4 py-2 text-gray-700"> 
                                        <button onClick={DeleteCont} id={contact.id} type="button">
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default Contacts;